import styled, { CSSProperties } from "styled-components";

export const HudContainer = styled.div<{
	$activeDot: string;
	$inactiveDot: string;
}>`
	position: relative;
	z-index: 1000;
	font-size: clamp(10px, 1vw, 16px);
	width: 10.9em;
	height: 10.9em;
	cursor: pointer;

	.swiper {
		width: 100%;
		height: calc(100% + 1em);
		overflow: visible;
		touch-action: pan-y;
	}

	.swiper-wrapper {
		height: calc(100% - 2em);
	}

	.swiper-slide {
		height: 100%;

		.hud-offer-image,
		.hud-offer-timer {
			opacity: 0;
			transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
			will-change: opacity, transform;
		}

		.hud-offer-image {
			transform: scale(0);
			transform-origin: center;
		}

		.hud-offer-timer {
			transform: scale(0);
			transform-origin: center;
		}
	}

	.swiper-slide-active {
		.hud-offer-image,
		.hud-offer-timer {
			opacity: 1;
		}

		.hud-offer-image {
			transform: scale(1);
		}

		.hud-offer-timer {
			transform: scale(1);
		}
	}

	.swiper-pagination {
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.swiper-pagination-bullet {
		width: 1.6em;
		height: 1.6em;
		margin: 0 !important;
		padding: 0;
		border: 0;
		border-radius: 0;
		opacity: 1;
		background: transparent url("${({ $inactiveDot }) => $inactiveDot}") center /
			contain no-repeat;
		touch-action: manipulation;
		-webkit-tap-highlight-color: transparent;
		-webkit-appearance: none;
		appearance: none;
		outline: none;
		box-shadow: none;

		&:focus,
		&:active {
			outline: none;
			box-shadow: none;
		}

		&.swiper-pagination-bullet-active {
			background: transparent url("${({ $activeDot }) => $activeDot}") center /
				contain no-repeat;
		}
	}

	.swiper-pagination-bullet + .swiper-pagination-bullet {
		margin-left: 0.4em !important;
	}
`;
export const HudItemContainer = styled.div`
	position: relative;
	font-size: 1em;
	width: 100%;
	height: 100%;
`;

export const HudVisual = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

export const HudImageContainer = styled.div<{ $backgroundImage: string }>`
	position: absolute;
	top: 0;
	left: 50%;
	width: calc(100% - 1em);
	height: calc(100% - 0.5em);
	transform: translateX(-50%);
	z-index: 1;
	background-image: url("${({ $backgroundImage }) => $backgroundImage}");
	background-position: bottom center;
	background-repeat: no-repeat;
	background-size: contain;

	> img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
`;

export const HudTimerContainer = styled.div`
	position: absolute;
	top: 0;
	left: 50%;
	z-index: 2;
	pointer-events: none;
	transform: translateX(-50%);
`;

export const HudTimerAnimation = styled.div`
	transform-origin: center;
`;

export const hudDipTimer: CSSProperties = {
	position: "static",
	color: "#fff",
	textShadow: "0 0.106em 0 rgba(0, 0, 0, 0.25)",
	fontFamily: "Inter",
	fontSize: "1em",
	fontStyle: "normal",
	fontWeight: 700,
	lineHeight: "130%",
	padding: "0.2em 0.5em",
	borderRadius: "16px",
	margin: 0,
	whiteSpace: "nowrap"
};

export const hudDipTimerText: CSSProperties = {
	margin: 0
};

export const Ribbon = styled.div<{ $backgroundImage: string }>`
	position: absolute;
	left: 50%;
	bottom: 0;
	width: 110%;
	height: 2.8em;
	transform: translateX(-50%);
	z-index: 2;
	background-image: url("${({ $backgroundImage }) => $backgroundImage}");
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
`;

export const RibbonText = styled.div`
	position: absolute;
	left: 50%;
	bottom: 0.4em;
	transform: translateX(-50%);
	color: #fff;
	text-align: center;
	text-shadow: 0 0.106em 0 rgba(0, 0, 0, 0.25);
	font-family: Baloo;
	font-size: 1.1em;
	font-style: normal;
	font-weight: 400;
	line-height: 106%;
	width: 100%;
`;
